import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Home from "./pages/Home";
import WorksheetPage from "./pages/WorksheetPage";
import WorksheetsList from "./pages/WorksheetsList";
import GradesPage from "./pages/GradesPage";
import SubjectsPage from "./pages/SubjectsPage";
import WorksheetsSeoPage from "./pages/WorksheetsSeoPage";
import OnlinePractice from "./pages/OnlinePractice";
import GradeSubjectsPage from "./pages/GradeSubjectsPage";

function GuardedRoute({ children }){
  const location = useLocation();
  const cameFromApp = location.state && location.state.fromApp;
  if (!cameFromApp) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (

    <Router>

      <Routes>

        <Route path="/" element={<Home />} />

        <Route path="/worksheets" element={<WorksheetsList />} />
        <Route path="/worksheets/subject/:subjectSlug" element={<WorksheetsSeoPage />} />
        <Route path="/worksheets/:classSlug" element={<WorksheetsSeoPage />} />
        <Route path="/worksheets/:classSlug/:subjectSlug" element={<WorksheetsSeoPage />} />
        <Route
          path="/grades"
          element={
            <GuardedRoute>
              <GradesPage />
            </GuardedRoute>
          }
        />
        <Route path="/grades/:classSlug" element={<GradeSubjectsPage />} />
        <Route
          path="/subjects"
          element={
            <GuardedRoute>
              <SubjectsPage />
            </GuardedRoute>
          }
        />

        <Route path="/practice" element={<OnlinePractice />} />

        <Route path="/worksheet/:id" element={<WorksheetPage />} />


      </Routes>

      <Analytics />

    </Router>

  );
}

export default App;
